import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { DocumentNavigationComponent } from 'app/common/components/document-navigation/document-navigation.component';

/**
 * Serial Navigation Cell Renderer for Charge In/Out (DT003)
 *
 * Displays document serial number with navigation capability to Charge In/Out detail page.
 * Document type is hardcoded as DT003 (Carga In/Out).
 *
 * @example
 * ```typescript
 * {
 *   field: 'serials',
 *   headerName: 'Nro. Doc.',
 *   cellRenderer: ChargeInOutSerialNavigationCellRendererComponent,
 *   cellRendererParams: {
 *     documentType: 'DT003'
 *   },
 *   minWidth: 160,
 *   sortable: true,
 * }
 * ```
 */
@Component({
  selector: "app-charge-inout-serial-navigation-cell-renderer",
  standalone: true,
  imports: [CommonModule, DocumentNavigationComponent],
  template: `
    <app-document-navigation
      [documentType]="documentType"
      [documentSerial]="documentSerial"
      [displayText]="documentSerial"
      [showIcon]="true"
    >
    </app-document-navigation>
  `,
})
export class ChargeInOutSerialNavigationCellRendererComponent
  implements CellRenderer<any>
{
  @Input() params!: CellRendererParams<any>;

  get documentType(): string {
    return this.params?.cellRendererParams?.documentType ??
           this.params?.data?.documentType ??
           'DT003'; // Charge In/Out document type
  }

  get documentSerial(): string | undefined {
    return this.params?.data?.serials;
  }
}
